// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// ///////////////////////////////////////////////////////////////////////////////////////////
import { DoubleMatrix, ExpandDoubleVector } from './DoubleMatrix';
export class CloudVector extends DoubleMatrix {
    constructor(count, firstLineColor, secondLineColor, gradientMethod) {
        super();
        this.valueShift = 0;
        this.FFirstLineColor = firstLineColor;
        this.FSecondLineColor = secondLineColor;
        this.FGradientMethod = gradientMethod;
        // this.FArray = new ExpandDoubleVector();
        this.FArray[0] = new ExpandDoubleVector(count, 0);
        this.FArray[1] = new ExpandDoubleVector(count, 0);
        this.FArray[0].Shift = 0;
        this.FArray[1].Shift = 0;
    }
    get GRADIENT_NONE() {
        return 0;
    }
    get GRADIENT_SIMPLE() {
        return 1;
    }
    get GRADIENT_LENEAR() {
        return 2;
    }
    get FirstLineColor() {
        return this.FFirstLineColor;
    }
    set FirstLineColor(value) {
        this.FFirstLineColor = value;
    }
    get SecondLineColor() {
        return this.FSecondLineColor;
    }
    set SecondLineColor(value) {
        this.FSecondLineColor = value;
    }
    get GradientMethod() {
        return this.FGradientMethod;
    }
    set GradientMethod(value) {
        this.FGradientMethod = value;
    }
    Add(value) {
        this.FArray[0].Add(value);
        this.FArray[1].Add(value);
    }
    Get(index) {
        return this.FArray[index];
    }
    get Shift() {
        return this.FArray[0].Shift || 0;
    }
    set Shift(value) {
        this.FArray[0].Shift = this.FArray[1].Shift = value || 0;
    }
}
